import { useCallback, useEffect, useMemo, useState } from "react";

import {
  getMediaVariantCandidates,
  type MediaUrlVariant,
} from "@/utils/mediaUrlVariants";

export function useImagePreview({
  preferredVariant = "thumbnail",
  url,
}: {
  preferredVariant?: MediaUrlVariant;
  url?: string;
}): { hasFailed: boolean; onError: () => void; src: string } {
  const candidates = useMemo(
    () => getMediaVariantCandidates(url ?? "", preferredVariant),
    [preferredVariant, url],
  );
  const [candidateIndex, setCandidateIndex] = useState(0);
  const [hasFailed, setHasFailed] = useState(false);

  useEffect(() => {
    setCandidateIndex(0);
    setHasFailed(false);
  }, [candidates]);

  const onError = useCallback(() => {
    setCandidateIndex((currentIndex) => {
      if (currentIndex >= candidates.length - 1) {
        setHasFailed(true);

        return currentIndex;
      }

      return currentIndex + 1;
    });
  }, [candidates.length]);

  return { hasFailed, onError, src: candidates[candidateIndex] ?? "" };
}
